import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutRightFull: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"layout-right-full, grid, window"} maskId="square-filled-radius-0-stroke-1-IconLayoutRightFull"><path d="M3 21V3H14L14 21L3 21Z" fill="currentColor"/><path d="M15 21L21 21V3H15L15 21Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconLayoutRightFull;
